(function (Drupal, $) {
  Drupal.behaviors.slickCarousel = {
    attach: function attach(context) {

      let threshold = 768;
      let xlThreshold = 1200;
      let xxlThreshold = 1440;
      let xxxlThreshold = 1920;

      let prevArrow = '<button class="left" aria-label="previous slide"><svg width="15px" height="22px" viewBox="0 0 15 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
        '            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '              <g transform="translate(-62.000000, -335.000000)" stroke="#000000" stroke-width="6">\n' +
        '                <g>\n' +
        '                  <g>\n' +
        '                    <g transform="translate(71.000000, 346.000000) scale(-1, 1) translate(-71.000000, -346.000000) translate(49.000000, 324.000000)">\n' +
        '                      <g>\n' +
        '                        <polyline points="19 13 27 22 19 31"></polyline>\n' +
        '                      </g>\n' +
        '                    </g>\n' +
        '                  </g>\n' +
        '                </g>\n' +
        '              </g>\n' +
        '            </g>\n' +
        '          </svg></button>';

      let nextArrow = '<button class="right" aria-label="Next slide"><svg width="15px" height="22px" viewBox="0 0 15 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
        '            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '              <g transform="translate(-1277.000000, -335.000000)" stroke="#000000" stroke-width="6">\n' +
        '                <g>\n' +
        '                  <g transform="translate(1261.000000, 324.000000)">\n' +
        '                    <g>\n' +
        '                      <polyline points="19 13 27 22 19 31"></polyline>\n' +
        '                    </g>\n' +
        '                  </g>\n' +
        '                </g>\n' +
        '              </g>\n' +
        '            </g>\n' +
        '          </svg></button>';

      if (!$('.txrh-hero-carousel .carousel-item__hero-static').length) {
        $(context).find(".txrh-hero-carousel .carousel-items__list").each(function() {
          $(this).slick({
            prevArrow,
            nextArrow,
            mobileFirst: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: $(this).children('div').length > 1, //only show dots if there is more than one slide
            rows: 1,
            cssEase: "ease",
            easing: "linear",
            slidesPerRow: 1,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 500,
            responsive: [
              {
                breakpoint: threshold - 1, //apply change right at 728 width
                settings: {
                  arrows: true,
                }
              },
              {
                breakpoint: xlThreshold - 1, //apply change right at 1200 width
                settings: {
                  arrows: true,
                }
              },
              {
                breakpoint: xxlThreshold - 1, //apply change right at 1440 width
                settings: {
                  arrows: true,
                }
              },
              {
                breakpoint: xxxlThreshold - 1, //apply change right at 1920 width
                settings: {
                  arrows: true,
                }
              }
            ]
          });
        });
      }

      $(context).find(".image-carousel").each(function() {
        $(this).slick({
          prevArrow,
          nextArrow,
          mobileFirst: true,
          arrows: true,
          dots: $(this).children('div').length > 1,
          responsive: [
            {
              breakpoint: threshold - 1, //apply change right at 728 width
              settings: {
                arrows: true,
              }
            }
          ]
        });
      });

      function setupLocalStoriesSlider() {
        if ($(window).width() < xlThreshold) {
          $(context).find(".teaser-tall-block:not(.no-cta-image) .field__field-teaser-tall-content").slick({
            prevArrow,
            nextArrow,
            mobileFirst: true,
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: threshold - 1, //apply change right at 728 width
                settings: {
                  arrows: true,
                }
              },
              {
                breakpoint: xlThreshold - 1, //apply change right at 728 width
                settings: "unslick"
              }
            ]
          });

        }
      }

      function setupGallerySlider() {
        if($(window).width() < threshold) {
          $(context).find(".gallery-block-list .field__field-gallery-image").slick({
            mobileFirst: true,
            arrows: false,
            dots: false,

            responsive: [
              {
                breakpoint: threshold - 1, //apply change right at 728 width
                settings: "unslick"
              }
            ]
          });
        }
      }

      //.field__field-teaser-content
      function setupSustainabilitySlider() {
        //if ($(window).width() < xlThreshold) {
          let slideCount = $(context).find(".field__field-teaser-content .paragraph--type--image-teaser").length;
          let xlSettings = "unslick";

          if ( slideCount >= 3 ) {
            xlSettings = {
              arrows: true,
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: (slideCount <= 4 ? false : true )
            };
          }
          $(context).find(".field__field-teaser-content").slick({
            prevArrow,
            nextArrow,
            mobileFirst: true,
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: threshold - 1, //apply change right at 728 width
                settings: {
                  arrows: true,
                }
              },
              {
                breakpoint: xlThreshold - 1, //apply change right at 1200 width
                settings: xlSettings
              }
            ]
          });
        //}
      }

      function setupMobileLayoutSlider() {
        //if ($(window).width() < xlThreshold) {
        let slideCount = $(context).find(".layout-slider-mobile .layout__region").length;
        let xlSettings = "unslick";

        $(context).find(".layout-slider-mobile").slick({
          prevArrow,
          nextArrow,
          mobileFirst: true,
          arrows: false,
          dots: true,
          // centerMode: true,
          // slidesToShow: 1.5,
          responsive: [
            {
              breakpoint: threshold - 1, //apply change right at 728 width
              settings: {
                arrows: false,
              }
            },
            {
              breakpoint: xlThreshold - 1, //apply change right at 1200 width
              settings: xlSettings
            }
          ]
        });
        //}
      }

      setupGallerySlider();
      setupLocalStoriesSlider();
      setupSustainabilitySlider();
      $(window).on('resize', function(){
        setupGallerySlider();
        setupLocalStoriesSlider();
        setupSustainabilitySlider();
      });

      if ($('.layout-slider-mobile').length && window.innerWidth < threshold) {
        console.log('Layout Slider init');
        setupMobileLayoutSlider();
      }


    }
  };
})(Drupal, jQuery);
